// Navigation helpers for the header. The menu itself (panels, links, images)
// is built from the live catalog in lib/menu.ts; this file holds the pieces
// that do not depend on the catalog.

import type { SiteMenu } from "./menu";

/** Which top-level menu section a route belongs to (for the bracket indicator). */
export function sectionForPath(pathname: string): string | null {
  if (pathname === "/men" || pathname.startsWith("/men/")) return "men";
  if (pathname === "/women" || pathname.startsWith("/women/")) return "women";
  if (pathname === "/brands" || pathname.startsWith("/brands/")) return "brands";
  if (pathname === "/new-arrivals") return "new-in";
  return null;
}

/** Used when the catalog cannot be loaded: no panels, just a plain Shop link. */
export const FALLBACK_MENU: SiteMenu = {
  panels: [],
  plain: [{ label: "Shop", href: "/shop" }],
  utility: [
    { label: "Our Story", href: "/#our-story" },
    { label: "Contact", href: "/#contact" },
  ],
};
